import { PlayType } from '../Model/TableModel';

const supportPlayType: { [key in PlayType]: boolean } = {
    [PlayType.Crowd]: false,
    [PlayType.Multiple]: true,
    [PlayType.Round]: true,
    [PlayType.Single]: true,
    [PlayType.Stage]: false,
    [PlayType.Party]: false,
    [PlayType.MiniGame]: false,
};

export default supportPlayType;
